import { render, staticRenderFns } from "./AlgTelegramIcon.vue?vue&type=template&id=4178a8c4&scoped=true&"
import script from "./AlgTelegramIcon.vue?vue&type=script&lang=js&"
export * from "./AlgTelegramIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4178a8c4",
  null
  
)

export default component.exports